import { z } from 'zod';
export const EnvironmentSchema = z.enum(['local', 'staging', 'production']);
export const BaseConfigSchema = z.object({
    environment: EnvironmentSchema,
    logLevel: z.enum(['debug', 'info', 'warn', 'error']).default('info'),
    sentry: z
        .object({
        dsn: z.string().optional(),
        debug: z.boolean().default(false),
        tracesSampleRate: z.number().min(0).max(1).default(0.1),
        profilesSampleRate: z.number().min(0).max(1).default(0.1),
    })
        .optional(),
});
export const LogLevelSchema = z.enum(['debug', 'info', 'warn', 'error']);
